"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchSyncScheduledChargesResponse = exports.SyncScheduledChargesResponse = exports.ChargeAmount = exports.AllChargeDetail = exports.ScheduledCharge = exports.ScheduledChargeGroup = void 0;
var enums_1 = require("./enums");
var ScheduledChargeGroup = /** @class */ (function () {
    function ScheduledChargeGroup() {
        this.orgId = 0;
        this.leaseId = 0;
        this.propertyId = 0;
        this.leaseIntervalId = 0;
        this.arTriggerId = 0;
        this.arTriggerName = '';
        this.installmentId = 0;
        this.endsWithMoveOut = true;
        this.chargeAmount = new ChargeAmount();
        this.totalValue = 0;
        this.totalValueWithTax = 0;
        this.ledgerFilterId = 0;
        this.arCodeGroupTypeId = 0;
        this.arCodeGroupName = '';
        this.arCodeName = '';
        this.isHistorical = false;
        this.customerName = '';
        this.taxAmount = 0;
        this.summarizationGroupId = 0;
        this.allChargesDetails = [];
        this.source = enums_1.ScheduledChargeSource.Pricing;
    }
    return ScheduledChargeGroup;
}());
exports.ScheduledChargeGroup = ScheduledChargeGroup;
var ScheduledCharge = /** @class */ (function () {
    function ScheduledCharge() {
        this.scheduledChargeId = 0;
        this.arCodeId = 0;
        this.arCodeName = '';
        this.chargeAmount = 0;
    }
    return ScheduledCharge;
}());
exports.ScheduledCharge = ScheduledCharge;
var AllChargeDetail = /** @class */ (function () {
    function AllChargeDetail() {
        this.scheduledChargeId = 0;
        this.arCodeId = 0;
        this.arCodeName = '';
        this.arCodeTypeId = 0;
        this.arOriginId = 0;
        this.arOriginName = '';
        this.chargeAmount = 0;
        this.arOriginReferenceId = 0;
        this.arOriginReferenceName = null;
        this.arOriginObjectId = null;
        this.leaseAssociationId = null;
        this.arFormulaId = 0;
        this.isOptional = null;
        this.timing = '';
        this.frequency = '';
        this.method = '';
        this.requirementType = '';
        this.description = undefined;
    }
    return AllChargeDetail;
}());
exports.AllChargeDetail = AllChargeDetail;
var ChargeAmount = /** @class */ (function () {
    function ChargeAmount() {
        this.amountNumber = 0;
        this.amountFormatted = '';
        this.currencyCode = '';
        this.isRange = undefined;
        this.minAmountNumber = undefined;
        this.maxAmountNumber = undefined;
        this.minAmountFormatted = undefined;
        this.maxAmountFormatted = undefined;
        this.customFeeAmountType = undefined;
        this.amountDetail = undefined;
    }
    return ChargeAmount;
}());
exports.ChargeAmount = ChargeAmount;
var SyncScheduledChargesResponse = /** @class */ (function () {
    function SyncScheduledChargesResponse() {
        this.charges = [];
        this.notifications = [];
    }
    return SyncScheduledChargesResponse;
}());
exports.SyncScheduledChargesResponse = SyncScheduledChargesResponse;
var BatchSyncScheduledChargesResponse = /** @class */ (function () {
    function BatchSyncScheduledChargesResponse() {
        this.charges = [];
        this.notifications = [];
    }
    return BatchSyncScheduledChargesResponse;
}());
exports.BatchSyncScheduledChargesResponse = BatchSyncScheduledChargesResponse;
